const Language = {
    EN: "EN",
    PL: "PL"
}

export default Language;